import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { TvaSessionService } from '../tva-session.service';

@Component({
  selector: 'app-tva-session-sidebar',
  templateUrl: './tva-session-sidebar.component.html',
  imports: [TranslatePipe],
  styleUrls: ['./tva-session-sidebar.component.css'],
})
export class TvaSessionSidebarComponent {
  private readonly tvaSessionService = inject(TvaSessionService);

  /**
   * Reset the table.
   * Default tableView from defaultTableViewColumnStateFor<areaName>.json will get used
   * See also: table-view-administration-custom.service
   */
  public onBtnResetDefaultTableView(): void {
    if (this.tvaSessionService.gridApi != undefined) {
      this.tvaSessionService.gridApi.resetColumnState();
      this.tvaSessionService.gridApi.resetColumnGroupState();
      this.tvaSessionService.gridApi.applyColumnState({
        state: null,
        applyOrder: false,
        defaultState: { sort: null },
      });
      this.tvaSessionService.gridApi.updateGridOptions({
        pivotMode: this.tvaSessionService.isTableWithPivotFunctionality,
      });
      this.tvaSessionService.gridApi.collapseAll();
      this.tvaSessionService.gridApi.setFilterModel(null);
      this.tvaSessionService.gridApi.sizeColumnsToFit();
    }
  }

  public onResize(): void {
    this.tvaSessionService.gridApi.sizeColumnsToFit();
  }
}
